import { Input, Label } from "@/components/ui/input";
import { ToggleGroup } from "@/components/ui/select";

export interface DateRange {
  from: string;
  to: string;
}

function iso(d: Date): string {
  return d.toISOString().slice(0, 10);
}

function daysAgo(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return iso(d);
}

export const PRESETS = [
  { label: "7 days", value: "7" },
  { label: "30 days", value: "30" },
  { label: "90 days", value: "90" },
  { label: "This month", value: "mtd" },
  { label: "This year", value: "ytd" },
  { label: "Custom", value: "custom" },
];

export function rangeForPreset(preset: string): DateRange {
  const today = iso(new Date());
  if (preset === "mtd") {
    const d = new Date();
    d.setDate(1);
    return { from: iso(d), to: today };
  }
  if (preset === "ytd") {
    return { from: `${new Date().getFullYear()}-01-01`, to: today };
  }
  const days = Number(preset);
  if (Number.isFinite(days)) return { from: daysAgo(days - 1), to: today };
  return { from: daysAgo(29), to: today };
}

export function DateRangeFilter({
  preset,
  range,
  onPresetChange,
  onRangeChange,
}: {
  preset: string;
  range: DateRange;
  onPresetChange: (preset: string) => void;
  onRangeChange: (range: DateRange) => void;
}) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <Label className="mb-1.5 block">Period</Label>
        <ToggleGroup
          value={preset}
          onValueChange={onPresetChange}
          options={PRESETS}
        />
      </div>

      {preset === "custom" && (
        <>
          <div>
            <Label htmlFor="from" className="mb-1.5 block">
              From
            </Label>
            <Input
              id="from"
              type="date"
              value={range.from}
              max={range.to}
              onChange={(e) => onRangeChange({ ...range, from: e.target.value })}
              className="w-40"
            />
          </div>
          <div>
            <Label htmlFor="to" className="mb-1.5 block">
              To
            </Label>
            <Input
              id="to"
              type="date"
              value={range.to}
              min={range.from}
              onChange={(e) => onRangeChange({ ...range, to: e.target.value })}
              className="w-40"
            />
          </div>
        </>
      )}
    </div>
  );
}
